export var styleClasses = {
    wrapper: "untrusive-wrapper",
    wrapper_active: "untrusive-active",
    bar: "untrusive-bar",
};
//# sourceMappingURL=styleClasses.js.map